export const AdminPrefix = '/admin'

export const AdminPath = {
  AdminDashboard: '/dashboard',
  AdminHoardings: '/hoardings',
  AdminQuotations: '/quotations',
  AdminCampaigns: '/campaigns',
  AdminResources: '/resources',
  AdminVendors: '/vendors',
  AdminSettings: '/settings',
}
